module.exports = __webpack_public_path__ + "img/checklist-pink.993c512f.svg";